import React, {useEffect} from 'react';
import './toast.component.scss';

const ToastComponent = props => {
    let { closeNetworkCoveragePopup,successToast,toastMessage,closeToastTime, topPosition = 150  } = props;
    let timeID;
    if(closeToastTime){
       timeID =   setTimeout(() => {
            closeNetworkCoveragePopup()
        }, closeToastTime);
    }
    const addClass = () =>{
        let className='';
        if(successToast ==='success'){
            className='greenshade';
        } else if(successToast ==='warning'){
            className='orangeshade';
        } else {
            className='validateShade';
        }
        return className;
    }

    useEffect(() => {
        return () => {
            clearTimeout(timeID);
        }
    }, [])

    return (
         <div className="network-coverage">
        <div className={`coverageContent topspace ${addClass()}`} style = {{top: `${topPosition}px`}}>
          { typeof toastMessage === 'string' && <p dangerouslySetInnerHTML={{__html: toastMessage  ? toastMessage : 'add text here.'}}></p> }
          { typeof toastMessage === 'object' &&  <p>{toastMessage  ? toastMessage : 'add text here.'}</p>}
            <div className="crossIcon" onClick={() => closeNetworkCoveragePopup()}>
                <i className="material-icons">
                    clear
                </i>
            </div>
        </div>
    </div >
    )
}

export default ToastComponent
